export default "__VITE_ASSET__BKdXgTM7__";